import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-910853fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-signatory-modal" }
const _hoisted_2 = { class: "heading-text" }
const _hoisted_3 = { class: "line1" }
const _hoisted_4 = { class: "line2" }
const _hoisted_5 = { class: "ls-table" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "text" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-up" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["colspan"]
const _hoisted_12 = { "data-label": "LawId" }
const _hoisted_13 = { "data-label": "Name" }
const _hoisted_14 = { "data-label": "Position" }
const _hoisted_15 = { "data-label": "SolelyJointly" }
const _hoisted_16 = { "data-label": "From" }
const _hoisted_17 = { "data-label": "To" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " If this list is not up to date after performing the Managed Authorised Signatories process, please close the Part B form and re-open. ", -1))
const _hoisted_19 = {
  class: "mt-4",
  style: {"text-align":"right"}
}

export function render(_ctx, _cache) {
  const _component_ModalBox = _resolveComponent("ModalBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ModalBox, {
      onClose: _cache[1] || (_cache[1] = $event => (_ctx.cancelClicked()))
    }, {
      "header-text": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.headerText), 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.line2Text), 1)
        ])
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", null, " This table shows the Authorised Signatories for " + _toDisplayString(this.complianceFormB.complianceYear.name) + " Trust Lodgement. If you believe these are not correct, please press the 'Close' button, then answer the question as 'No', and finally click the 'Managed Authorised Signatories' button to update them before proceeding. ", 1),
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings, (h, index) => {
                return (_openBlock(), _createElementBlock("th", {
                  class: _normalizeClass([ h.sortable ? 'sortable' : '']),
                  onClick: $event => (_ctx.sortTableColumn(index, h.sortable))
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(h.text), 1),
                    (h.sortable)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass([ _ctx.activeSortHeader === index ? 'active' : '', _ctx.sortMethod])
                        }, _hoisted_9, 2))
                      : _createCommentVNode("", true)
                  ])
                ], 10, _hoisted_6))
              }), 256))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_ctx.signatoriesDisplay?.length == 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                  _createElementVNode("td", {
                    colspan: _ctx.tableHeadings.length
                  }, "No Records", 8, _hoisted_11)
                ]))
              : (_ctx.signatoriesDisplay?.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.signatoriesDisplay, (i) => {
                    return (_openBlock(), _createElementBlock("tr", null, [
                      _createElementVNode("td", _hoisted_12, _toDisplayString(i.lawId), 1),
                      _createElementVNode("td", _hoisted_13, _toDisplayString(i.name), 1),
                      _createElementVNode("td", _hoisted_14, _toDisplayString(i.categoryName), 1),
                      _createElementVNode("td", _hoisted_15, _toDisplayString(i.solelyJointlyName), 1),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.$formatDate(i.commencedDate)), 1),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(i.terminatedDate ? _ctx.$formatDate(i.terminatedDate) : ''), 1)
                    ]))
                  }), 256))
                : _createCommentVNode("", true)
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("button", {
            class: "btn btn-outline",
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.cancelClicked()))
          }, "Close")
        ])
      ]),
      _: 1
    })
  ]))
}